import { render, staticRenderFns } from "./DetailsMeetings.vue?vue&type=template&id=3761d32d&scoped=true"
import script from "./DetailsMeetings.vue?vue&type=script&lang=js"
export * from "./DetailsMeetings.vue?vue&type=script&lang=js"
import style0 from "./DetailsMeetings.vue?vue&type=style&index=0&id=3761d32d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3761d32d",
  null
  
)

export default component.exports